import React from "react";
import {
    MDBDropdown, MDBDropdownToggle, MDBDropdownMenu, MDBDropdownItem
} from 'mdbreact';
import { connect } from 'react-redux';
import store from "../../store";
import ReactDOM from "react-dom";

import {
    DrawerFichaImpresionDocumento
} from "../../action/actionCreators";
import { GetLicenciasSertecSocioEnAPI, EnviarCorreoRecuperacionUsuarioSertecEnAPI, DarBajaLicenciaSertecEnAPI, ObtenerTiposClientesEnAPI, ReactivarLicenciaEnAPI } from "../../action/actionCreatorsRequests";
import {
    convertirMoneda, obtenerToken,
    MSGOK, recortarCadena, obtenerUsuario, ordenarTablaLocal, traducirPagina

} from "../../librerias/funciones"
import FichaEstadistica from './FichaEstadistica'
import FichaImpresion from './FichaImpresionDocumento'
import FichaMantenimientoMostrador from './FichaMantenimientoMostrador'
import FichaMantenimientoCliente from './FichaMantenimientoCliente'
import FichaSelecionCliente from './FichaSeleccionCliente'
import { Button, Modal, Select, Row, Col, Pagination } from 'antd';
import {
    CloseOutlined,
    SearchOutlined,
    PlusOutlined,
    UnlockOutlined,
    ArrowUpOutlined,
    ArrowDownOutlined,
    CheckSquareOutlined,
    CloseSquareOutlined,
    ShopOutlined,
    UserOutlined,
    DesktopOutlined,
    MailOutlined,
    PrinterOutlined,
    EditOutlined,
    FundViewOutlined,
    DeleteOutlined,
    UserSwitchOutlined

} from '@ant-design/icons';


import { Layout } from 'antd';
import MantenimientoTienda from "../NextGroup/MantenimientoTienda";
const { Content } = Layout;
const { Option } = Select;

const LicenciasSertec = ({ activeItemReferencia, configApp, props }) => {
    const [alturaSubmenu, setAlturaSubmenu] = React.useState(0);
    const ref = React.useRef(null)


    const [tipoLicenciaUser, setTipoLicenciaUser] = React.useState({
        MOSTRADOR: -1,
        TALLER: -1,
        TIENDA: -1
    });


    const [hayLicencias, seHayLicencias] = React.useState(false);
    const [textoBuscador, setTextoBuscador] = React.useState("");

    const [sociosLocal, setSociosLocal] = React.useState([]);
    const [abrirFichaEstadistica, setAbrirFichaEstadistica] = React.useState(false);
    const [abrirFichaMostrador, setAbrirFichaMostrador] = React.useState(false);

    const [abrirFichaSelecionCliente, setAbrirFichaSelecionCliente] = React.useState(false);

    const [clienteFiltro, setClienteFiltro] = React.useState(null);


    const [socioSeleccionado, setSocioSeleccionado] = React.useState(0);
    const [usuarioSeleccionado, setUusuarioSeleccionado] = React.useState(0);
    const [registroUsuario, setRegistroUsuario] = React.useState({});
    const [visible, setVisible] = React.useState(false);
    const [registroTabla, setRegistroTabla] = React.useState([]);

    const [cabeceraTabla, setCabeceraTabla] = React.useState(
        {
            ID: false,
            Usuario: false,
            Nombre: false,
            Taller: false,
            Mail: false,
            Almacen: false,
            Cliente: false,
            Creación: false,
            Ultimo: false,
            Media: false,
            Activo: false,
            EsMostrador: false,
            Baja: false
        }
    );
    const [estadoCliente, setEstadoCliente] = React.useState(false);
    const [estadoMostrador, setEstadoMostrador] = React.useState(false);

    const [abrirFichaCliente, setAbrirFichaCliente] = React.useState(false);
    const [datosClienteSeleccionado, setDatosClienteSeleccionado] = React.useState({});
    const [licencias, setLicencias] = React.useState([]);
    const [licenciasAux, setLicenciasAux] = React.useState([]);

    const [datosPaginacion, setDatosPaginacion] = React.useState({ iniPage: 1, inicio: 1, final: 40, numPagina: 40 });

    const [filtroActivo, setFiltroActivo] = React.useState(0);
    const [filtroPorDecto, setFiltroPorDecto] = React.useState(0);
    const [tipoCliente, setTipoCliente] = React.useState([]);

    const [abrirFichaSelecionTienda, setAbrirFichaSelecionTienda] = React.useState(false);


    const [datosTiendaRetail, setDatosTiendaRetail] = React.useState({});



    const filtroLocalDeLaTabla = (textoAFiltrar, licenciasAux) => {
        let registrosEncontrados = [];
        let filtro = [...licenciasAux];

        if (textoAFiltrar.trim() !== "") {
            if (filtro !== null) {
                setDatosPaginacion({ iniPage: 1, inicio: 1, final: 40, numPagina: 40 })

                filtro.find(function (registro, i) {
                    if (registro.ID.toString().toLowerCase().includes(textoAFiltrar.toLowerCase()) || registro.ID.toString().toLowerCase() === textoAFiltrar.toLowerCase()) {
                        let existeRegistro = registrosEncontrados.find(reg => reg.ID === registro.ID)
                        if (existeRegistro === undefined) {
                            registrosEncontrados.push(registro)
                        }

                    }

                    if (registro.USUARIO.toLowerCase().includes(textoAFiltrar.toLowerCase())) {
                        let existeRegistro = registrosEncontrados.find(reg => reg.ID === registro.ID)
                        if (existeRegistro === undefined) {
                            registrosEncontrados.push(registro)
                        }

                    }

                    if (registro.NOMBRE_USUARIO.toLowerCase().includes(textoAFiltrar.toLowerCase())) {
                        let existeRegistro = registrosEncontrados.find(reg => reg.ID === registro.ID)
                        if (existeRegistro === undefined) {
                            registrosEncontrados.push(registro)
                        }
                    }

                    if (registro.NOMBRE_TALLER.toLowerCase().includes(textoAFiltrar.toLowerCase())) {
                        let existeRegistro = registrosEncontrados.find(reg => reg.ID === registro.ID)
                        if (existeRegistro === undefined) {
                            registrosEncontrados.push(registro)
                        }
                    }
                    if (registro.ALMACEN.toLowerCase().includes(textoAFiltrar.toLowerCase())) {
                        let existeRegistro = registrosEncontrados.find(reg => reg.ID === registro.ID)
                        if (existeRegistro === undefined) {
                            registrosEncontrados.push(registro)
                        }
                    }
                    if (registro.CLIENTE.toLowerCase().includes(textoAFiltrar.toLowerCase())) {
                        let existeRegistro = registrosEncontrados.find(reg => reg.ID === registro.ID)
                        if (existeRegistro === undefined) {
                            registrosEncontrados.push(registro)
                        }
                    }

                    if (registro.ULTIMO_ACCESO.toLowerCase().includes(textoAFiltrar.toLowerCase())) {
                        let existeRegistro = registrosEncontrados.find(reg => reg.ID === registro.ID)
                        if (existeRegistro === undefined) {
                            registrosEncontrados.push(registro)
                        }
                    }

                    if (registro.MEDIA.toString().toLowerCase().includes(textoAFiltrar.toLowerCase())) {
                        let existeRegistro = registrosEncontrados.find(reg => reg.ID === registro.ID)
                        if (existeRegistro === undefined) {
                            registrosEncontrados.push(registro)
                        }
                    }
                })

            }
            return registrosEncontrados.length > 0 ? registrosEncontrados : null

        } else {
            return filtro
        }
    }



    const altaClienteTienda = (REGISTRO_SELECCIONADO) => {
        const { CODIGO_CLIENTE_SOCIO, ID, NOMBRE, CIF, TELEFONO, POBLACION, RAZON, ID_TIPO_INTEGRACION } = REGISTRO_SELECCIONADO
        setAbrirFichaSelecionTienda(false)


        if (ID_TIPO_INTEGRACION !== 1) {
            setDatosTiendaRetail(REGISTRO_SELECCIONADO)
            setAbrirFichaSelecionCliente(true);
        } else {
            setAbrirFichaCliente(true)
        }

        setDatosClienteSeleccionado(
            {
                Codigo: CODIGO_CLIENTE_SOCIO,
                Cif: CIF,
                Telefono: TELEFONO,
                Poblacion: POBLACION,
                Razon: RAZON,
                ID_TIENDA_RETAIL: ID,
                NOMBRE_TIENDA_RETAIL: NOMBRE,
                ID_TIPO_INTEGRACION: ID_TIPO_INTEGRACION,

                CODIGO_CLIENTE_TIENDA: CODIGO_CLIENTE_SOCIO
            })
    }



    const licenciasSertec = (ORDERCOLUM, ORDERDIR, ID_SOCIO) => {
        setLicencias([]);
        setLicenciasAux([]);

        setEstadoCliente(false);
        setEstadoMostrador(false);
        setFiltroPorDecto(0);
        setTipoLicenciaUser({ MOSTRADOR: -1, TALLER: -1, TIENDA: -1 })

        setDatosPaginacion({ iniPage: 1, inicio: 1, final: 40, numPagina: 40 })


        GetLicenciasSertecSocioEnAPI(ORDERCOLUM, ORDERDIR, ID_SOCIO, null).then((licencias) => {
            if (licencias !== undefined) {
                if (licencias.LICENCIAS_SERTEC !== null && licencias.LICENCIAS_SERTEC.length > 0) {
                    setLicencias(licencias.LICENCIAS_SERTEC);
                    setLicenciasAux(licencias.LICENCIAS_SERTEC);

                } else {
                    setLicencias(null)
                    setLicenciasAux(null)
                }
            }
        })
    }



    const ObtenerTiposClientes = (ID, ID_SOCIO) => {
        ObtenerTiposClientesEnAPI(ID, ID_SOCIO).then((licencia) => {
            if (licencia !== undefined && licencia !== null && licencia.REGISTROS !== null && licencia.REGISTROS.length > 0) {
                setTipoCliente(licencia.REGISTROS)
            } else {
                setTipoCliente(null)
            }
        })
    }



    const ReactivarLicencia = (ID) => {
        ReactivarLicenciaEnAPI(ID).then((licencia) => {
            const { OK } = licencia
            if (OK) {
                MSGOK("msg_reactivar");

                licenciasSertec(1, "A", socioSeleccionado);
            }
        })
    }



    /*

    if (!hayLicencias && activeItemReferencia === "LICENCIAS_SERTEC") {

        seHayLicencias(true)
        let accesoLicencia = obtenerUsuario();
        setSociosLocal(accesoLicencia.SOCIOS)

        licenciasSertec(1, "A", accesoLicencia.SOCIOS[0].ID_SOCIO);
        setSocioSeleccionado(accesoLicencia.SOCIOS[0].ID_SOCIO)
    } else {
        if (activeItemReferencia !== "LICENCIAS_SERTEC" && hayLicencias) {
            seHayLicencias(false)
        }
    }
    */


    const actualizarCabeceraTabla = (e, valor) => {
        const ID = e === 'ID' ? valor : false;
        const Usuario = e === 'Usuario' ? valor : false;
        const Nombre = e === 'Nombre' ? valor : false
        const Taller = e === 'Taller' ? valor : false;
        const Mail = e === 'Mail' ? valor : false;
        const Almacen = e === 'Almacen' ? valor : false;
        const Cliente = e === 'Cliente' ? valor : false;
        const Creación = e === 'Creación' ? valor : false;
        const Ultimo = e === 'Ultimo' ? valor : false;
        const Media = e === 'Media' ? valor : false;
        const Activo = e === 'Activo' ? valor : false;
        const EsMostrador = e === 'EsMostrador' ? valor : false;
        const Baja = e === 'Baja' ? valor : false;


        setCabeceraTabla(
            {
                ID: ID,
                Usuario: Usuario,
                Nombre: Nombre,
                Taller: Taller,
                Mail: Mail,
                Almacen: Almacen,
                Cliente: Cliente,
                Creación: Creación,
                Ultimo: Ultimo,
                Media: Media,
                Activo: Activo,
                EsMostrador: EsMostrador,
                Baja: Baja
            }
        )
    }

    const MailDeRecuperacion = (ID) => {
        EnviarCorreoRecuperacionUsuarioSertecEnAPI(ID).then((mail) => {
            if (mail !== undefined) {
                if (mail.OK) {
                    MSGOK(traducirPagina("Mail_enviado"))
                }
            }
        })
    }

    const DarDeBajaUsuario = (ID) => {
        DarBajaLicenciaSertecEnAPI(ID).then((usuario) => {
            if (usuario !== undefined) {
                if (usuario.OK) {
                    MSGOK(traducirPagina("Usuario_baja"))

                    licenciasSertec(1, "A", socioSeleccionado);

                    setEstadoCliente(false);
                    setEstadoMostrador(false);
                    setFiltroPorDecto(0);
                    setTipoLicenciaUser({ MOSTRADOR: -1, TALLER: -1, TIENDA: -1 })

                }
            }
        })
    }

    const colorFondoMedia = (media) => {
        if (media < 25) { return "#f9c9c9" }
        if (media >= 25 && media < 50) { return "#f5d698" }
        if (media >= 50 && media < 75) { return "#f5f5b4" }
        if (media >= 75) { return "#e7f9c9" }

    }



    const filtrarDatosLocales = (licencias, esActivo, TIPO_LICENCIA, ID_TIPO_CLIENTE) => {
        const { TIENDA, MOSTRADOR, TALLER } = TIPO_LICENCIA

        let filtroLicencias = [...licencias];
        if (esActivo > 0) {
            filtroLicencias = licencias.filter((item) => (esActivo === 1) ? item.BAJA === 0 : item.BAJA === 1)
        }


        if (MOSTRADOR !== -1) {
            filtroLicencias = filtroLicencias.filter((item) => item.TIPO_LICENCIA === MOSTRADOR)
        }

        if (TALLER !== -1) {
            filtroLicencias = filtroLicencias.filter((item) => item.TIPO_LICENCIA === TALLER)
        }

        if (TIENDA !== -1) {
            filtroLicencias = filtroLicencias.filter((item) => item.TIPO_LICENCIA === TIENDA)
        }




        if (textoBuscador !== "") {
            filtroLicencias = filtroLocalDeLaTabla(textoBuscador, filtroLicencias)
        }

        if (ID_TIPO_CLIENTE !== null) {
            filtroLicencias = filtroLicencias.filter((item) => item.ID_TIPO_CLIENTE === ID_TIPO_CLIENTE)
        }


        let verificarLicencia = filtroLicencias === undefined || filtroLicencias === null ? null : filtroLicencias.length === 0 ? null : filtroLicencias
        setLicencias(verificarLicencia)
    }



    const List = React.memo(({ list }) => {
        let datos = [];

        datos = list.map((licencia, i) => (
            (i + 1) >= datosPaginacion.inicio && (i + 1) <= datosPaginacion.final ?
                <ListItem key={licencia.ID} licencia={licencia} />
                :
                null
        ))
        return (
            datos
        );
    })

    const ListItem = React.memo(({ licencia }) => {
        return <tr key={licencia.ID} style={{ backgroundColor: '#fff' }}>
            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }} title={licencia.ID}>{licencia.ID}</td>

            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }} title={licencia.USUARIO}>{recortarCadena(licencia.USUARIO, 20, "...")}</td>
            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }} title={licencia.NOMBRE_USUARIO}><span style={{ fontWeight: 500 }}> {recortarCadena(licencia.NOMBRE_USUARIO, 30, "...")}</span></td>
            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }} title={licencia.NOMBRE_TALLER}>{recortarCadena(licencia.NOMBRE_TALLER, 20, "...")}</td>
            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{licencia.ALMACEN}</td>
            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{licencia.CLIENTE}</td>
            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{licencia.ALTA}</td>
            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{licencia.FECHA_BAJA}</td>
            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{licencia.ULTIMO_ACCESO}</td>
            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center', backgroundColor: colorFondoMedia(licencia.MEDIA) }} >{convertirMoneda(licencia.MEDIA, "%")}</td>
            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{licencia.BAJA === 0 ? <CheckSquareOutlined style={{ fontSize: '18px', color: 'green' }} /> : <CloseSquareOutlined style={{ fontSize: '18px', color: 'red' }} />}</td>
            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{licencia.TIPO_LICENCIA === 0 ? <ShopOutlined style={{ fontSize: '18px', color: '#4285f4' }} /> : licencia.TIPO_LICENCIA === 1 ? <UserOutlined style={{ fontSize: '18px' }} /> : <UserSwitchOutlined style={{ fontSize: '18px', color: 'green' }}> </UserSwitchOutlined>}</td>
            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>
                <div className="flex-container-Grow-Simple">
                    {obtenerUsuario().ID_ROL === 2 ?
                        <div style={{ margin: '0px 2px' }}>
                            <button disabled={licencia.BAJA === 0 ? false : true} title={traducirPagina("Msg_login_tabla")} onClick={() => {
                                window.open("https://sertec.servicenext.eu/?user=" + licencia.USUARIO + "&pass=" + licencia.PWD, '_blank');
                            }}
                                className="btn-matricula  estiloBotonRemove paddindDeTres">
                                <DesktopOutlined style={{ cursor: 'pointer', fontSize: '20px', color: licencia.BAJA === 0 ? '#000' : '#999' }} />
                            </button>
                        </div>
                        : null
                    }


                    <div style={{ margin: '0px 2px' }} >
                        <button disabled={licencia.BAJA === 0 ? licencia.CORREO_RECUPERACION_PWD === "" ? true : false : true} title={traducirPagina("Enviar_correo_recuperacion")} onClick={() => {
                            MailDeRecuperacion(licencia.ID);
                        }}
                            className="btn-matricula  estiloBotonRemove paddindDeTres">
                            <MailOutlined style={{ cursor: 'pointer', fontSize: '20px', color: licencia.BAJA === 0 ? licencia.CORREO_RECUPERACION_PWD === "" ? '#ffb4b4' : '#000' : '#999' }} />
                        </button>
                    </div>

                    <div style={{ margin: '0px 2px' }}>
                        {licencia.ES_MOSTRADOR ?
                            <button disabled={licencia.BAJA === 0 ? false : true} title={traducirPagina("Administrar_licencias")} onClick={() => {
                                setUusuarioSeleccionado(licencia.ID);
                                setAbrirFichaMostrador(true);
                            }}
                                className="btn-matricula  estiloBotonRemove paddindDeTres">
                                <EditOutlined style={{ cursor: 'pointer', fontSize: '20px', color: licencia.BAJA === 0 ? '#000' : '#999' }} />
                            </button>
                            :
                            <button disabled={licencia.BAJA === 0 ? false : true} title={traducirPagina("Administrar_licencias")} onClick={() => {

                                setUusuarioSeleccionado(licencia.ID);
                                setAbrirFichaCliente(true)
                                //setAbrirFichaCliente(true)

                            }}
                                className="btn-matricula  estiloBotonRemove paddindDeTres">
                                <EditOutlined style={{ cursor: 'pointer', fontSize: '20px', color: licencia.BAJA === 0 ? '#000' : '#999' }} />
                            </button>
                        }
                    </div>

                    <div style={{ margin: '0px 2px' }} >
                        <button title={traducirPagina("Estadisticas")} onClick={() => {
                            setUusuarioSeleccionado(licencia.ID);
                            setRegistroUsuario(licencia)
                            setAbrirFichaEstadistica(true)

                        }}
                            className="btn-matricula  estiloBotonRemove paddindDeTres">
                            <FundViewOutlined style={{ cursor: 'pointer', fontSize: '20px', color: '#000' }} />
                        </button>
                    </div>

                    <div style={{ margin: '0px 2px' }} >
                        <button title={licencia.BAJA === 0 ? traducirPagina("Dar_baja") : traducirPagina("txt_reactivar")} onClick={() => {
                            if (licencia.BAJA === 0) {
                                setRegistroUsuario(licencia)
                                setVisible(true)
                            } else {
                                //Reactivar
                                ReactivarLicencia(licencia.ID)
                            }
                        }}
                            className="btn-matricula  estiloBotonRemove paddindDeTres">
                            {licencia.BAJA === 0 ?
                                <DeleteOutlined style={{ cursor: 'pointer', fontSize: '20px', color: '#000' }} />
                                :

                                <UnlockOutlined style={{ cursor: 'pointer', fontSize: '20px', color: '#000' }}></UnlockOutlined>
                            }

                        </button>
                    </div>
                </div>
            </td>
        </tr>
    });

    const paginarTabla = (page, pageSize) => {
        if (licencias.length > 0) {
            let pInicio = (pageSize * page) - (datosPaginacion.numPagina);
            let pFinal = pageSize * page;
            setDatosPaginacion(
                {
                    iniPage: page,
                    inicio: pInicio,
                    final: pFinal,
                    numPagina: datosPaginacion.numPagina
                }
            )
        }
    }

    const updateNumberPage = (current, size) => {
        setDatosPaginacion(
            {
                iniPage: 1,
                inicio: 1,
                final: size,
                numPagina: size
            }
        )
    }



    React.useEffect(() => {
        if (ref.current !== null) {
            setAlturaSubmenu(ref.current.clientHeight)
        }
    })



    React.useEffect(() => {
        if (obtenerToken() !== undefined) {
            let accesoLicencia = obtenerUsuario();
            setSociosLocal(accesoLicencia.SOCIOS)

            licenciasSertec(1, "A", accesoLicencia.SOCIOS[0].ID_SOCIO);
            setSocioSeleccionado(accesoLicencia.SOCIOS[0].ID_SOCIO)

            ObtenerTiposClientes(null, accesoLicencia.SOCIOS[0].ID_SOCIO)

        }
    }, [])



    document.getElementById("tituloMenu") !== null && ReactDOM.render(
        <>
            {`SERTEC - ${traducirPagina("Licencias").toUpperCase()}`}
        </>,
        document.getElementById("tituloMenu")
    );


    return (
        <div>

            <div className="menu_mantenimiento" ref={ref}>
                <div className="mantenimiento_item1" style={{ gap: '10px' }}>

                    <div className="grid-container" style={{ backgroundColor: '#eee' }}>
                        <div className="grid-item">
                            <input className="form-control eliminarFoco " type="text" aria-label="Search" placeholder={traducirPagina("Buscador_licencias")} style={{ backgroundColor: "transparent", border: '0px', height: '100%', color: '#000' }} name="txtInputCliente" autoComplete="off" onChange={(e) => {
                                setLicencias(filtroLocalDeLaTabla(e.target.value, licenciasAux));
                                setTextoBuscador(e.target.value)
                            }} value={textoBuscador} />
                        </div>

                        <div className="grid-item" >
                            <button style={{ visibility: textoBuscador.trim() === "" ? 'hidden' : 'visible' }} className="btn-matriculav2 btnEliminarBuscador" onClick={(e) => { setTextoBuscador(""); setLicencias(filtroLocalDeLaTabla("", licenciasAux)); }}>  <CloseOutlined style={{ color: '#666', cursor: 'pointer', fontSize: '20px' }} />  </button>
                        </div>

                        <div className="grid-item barraLateral" ></div>

                        <div className="grid-item">
                            <button className="btn-matricula btnEliminarBuscador">  <SearchOutlined style={{ color: '#666', cursor: 'pointer', fontSize: '20px' }} />  </button>
                        </div>
                    </div>


                    <div>
                        {sociosLocal !== null ?
                            <Select
                                showSearch
                                allowClear={obtenerUsuario().SOCIOS.length > 1 ? true : false}
                                defaultValue={obtenerUsuario().SOCIOS[0].ID_SOCIO}
                                size={"large"}
                                style={{ width: 250 }}
                                placeholder={traducirPagina("Seleccione_socio")}

                                optionFilterProp="children"
                                onChange={(e) => {

                                    if (e === undefined || e === null) {
                                        setLicencias(null)
                                        setFiltroActivo(0)
                                        setClienteFiltro(null)


                                    } else {
                                        setFiltroActivo(0)
                                        setClienteFiltro(null)

                                        setSocioSeleccionado(parseInt(e));
                                        licenciasSertec(1, "A", e);
                                        setTextoBuscador("")
                                        setRegistroTabla([])

                                        setEstadoCliente(false);
                                        setEstadoMostrador(false);

                                        setTipoLicenciaUser({ MOSTRADOR: -1, TALLER: -1, TIENDA: -1 })

                                        ObtenerTiposClientes(null, e)

                                    }
                                }}
                                filterOption={(input, option) =>
                                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                            >
                                {sociosLocal.length > 0 ?
                                    sociosLocal.map((socio) =>
                                        <Option key={socio.ID_SOCIO} value={socio.ID_SOCIO}>{socio.NOMBRE_SOCIO}</Option>
                                    )
                                    :
                                    null
                                }
                            </Select>
                            :
                            <div style={{ textAlign: 'center' }}>
                                <h4>{traducirPagina("Info_error_socio")}</h4>
                            </div>
                        }
                    </div>

                    <div>
                        <Select
                            showSearch
                            allowClear={true}
                            size={"large"}
                            value={filtroActivo === 0 ? <span style={{ color: '#999' }}>{traducirPagina("Filtrado_activo").toUpperCase()}</span> : filtroActivo === 1 ? traducirPagina("Activo").toUpperCase() : traducirPagina("Desactivo").toUpperCase()}
                            style={{ width: 250 }}
                            optionFilterProp="children"
                            onChange={(e) => {
                                if (e === undefined || e === null) {
                                    setFiltroActivo(0)
                                    //filtroLocalActivo(licenciasAux, 0)

                                    filtrarDatosLocales(licenciasAux, 0, filtroPorDecto)

                                } else {
                                    setFiltroActivo(e)
                                    //filtroLocalActivo(licenciasAux, e)

                                    filtrarDatosLocales(licenciasAux, e, filtroPorDecto)
                                }
                            }}
                            filterOption={(input, option) =>
                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                        >
                            <Option key={0} value={0}>{traducirPagina("Todos")}</Option>
                            <Option key={1} value={1}>{traducirPagina("Activo").toUpperCase()}</Option>
                            <Option key={2} value={2}>{traducirPagina("Desactivo").toUpperCase()}</Option>
                        </Select>
                    </div>

                    <div>
                        <Select
                            showSearch
                            allowClear={true}
                            disabled={tipoCliente === null ? true : false}
                            size={"large"}
                            value={clienteFiltro === null ? <span style={{ color: '#999' }}>{traducirPagina("Tipo_cliente").toUpperCase()}</span> : clienteFiltro}
                            style={{ width: "200px", textAlign: 'left', marginLeft: '10px' }}
                            optionFilterProp="children"
                            onChange={(e) => {
                                let CLIENTE = e === undefined || e === null ? null : e;
                                setClienteFiltro(CLIENTE)

                                filtrarDatosLocales(licenciasAux, filtroActivo, tipoLicenciaUser, CLIENTE)


                            }}
                            filterOption={(input, option) =>
                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                        >

                            <Option key={0} value={0}>{traducirPagina("Sin_asignar").toUpperCase()}</Option>

                            {tipoCliente !== null && tipoCliente.length > 0 ?
                                tipoCliente.map((registro) =>
                                    <Option key={registro.ID} value={registro.ID}>{registro.DESCRIPCION}</Option>
                                )
                                :
                                null
                            }

                        </Select>
                    </div>




                    <UserOutlined style={{ fontSize: '20px', fontSize: '20px', verticalAlign: 'bottom', marginLeft: '10px', color: tipoLicenciaUser.TALLER === 1 ? '#1890ff' : '#000', cursor: 'pointer' }} onClick={() => {
                        //cambiosFiltro(2, licenciasAux)

                        tipoLicenciaUser.TALLER = tipoLicenciaUser.TALLER === 1 ? -1 : 1

                        tipoLicenciaUser.MOSTRADOR = -1
                        tipoLicenciaUser.TIENDA = -1
                        setTipoLicenciaUser({ ...tipoLicenciaUser })

                        filtrarDatosLocales(licenciasAux, filtroActivo, tipoLicenciaUser, clienteFiltro)


                    }} />

                    <ShopOutlined style={{ fontSize: '20px', fontSize: '20px', verticalAlign: 'bottom', marginLeft: '10px', color: tipoLicenciaUser.MOSTRADOR === 0 ? '#1890ff' : '#000', cursor: 'pointer' }} onClick={() => {
                        //cambiosFiltro(1, licenciasAux)
                        tipoLicenciaUser.MOSTRADOR = tipoLicenciaUser.MOSTRADOR === 0 ? -1 : 0

                        tipoLicenciaUser.TALLER = -1
                        tipoLicenciaUser.TIENDA = -1

                        setTipoLicenciaUser({ ...tipoLicenciaUser })

                        filtrarDatosLocales(licenciasAux, filtroActivo, tipoLicenciaUser, clienteFiltro)
                    }} />


                    <UserSwitchOutlined style={{ fontSize: '20px', fontSize: '20px', verticalAlign: 'bottom', marginLeft: '10px', color: tipoLicenciaUser.TIENDA === 2 ? '#1890ff' : '#000', cursor: 'pointer' }} onClick={() => {
                        //cambiosFiltro(1, licenciasAux)
                        tipoLicenciaUser.TIENDA = tipoLicenciaUser.TIENDA === 2 ? -1 : 2

                        tipoLicenciaUser.TALLER = -1
                        tipoLicenciaUser.MOSTRADOR = -1
                        setTipoLicenciaUser({ ...tipoLicenciaUser })

                        filtrarDatosLocales(licenciasAux, filtroActivo, tipoLicenciaUser, clienteFiltro)

                    }} />


                    <PrinterOutlined style={{ color: '#1890ff', fontSize: '20px' }} onClick={(e) => { store.dispatch(DrawerFichaImpresionDocumento(true)); }} />

                    <div>
                        <MDBDropdown>
                            <MDBDropdownToggle nav>
                                <button style={{ height: '40px', width: '50px', border: '0', borderRadius: '3px', fontSize: '13px', verticalAlign: 'bottom', color: '#1890ff', backgroundColor: '#efefef', cursor: 'pointer' }} onClick={() => { }}><PlusOutlined style={{ fontSize: '20px' }} />  </button>
                            </MDBDropdownToggle>
                            <MDBDropdownMenu right >
                                <MDBDropdownItem onClick={() => { setAbrirFichaMostrador(true); setUusuarioSeleccionado(-1) }}> <ShopOutlined style={{ fontSize: '18px', verticalAlign: 'initial', width: '24px' }} />  {traducirPagina("Mostrador").toUpperCase()}</MDBDropdownItem>
                                <MDBDropdownItem onClick={() => { setAbrirFichaSelecionCliente(true); }}> <UserOutlined style={{ fontSize: '18px', verticalAlign: 'initial', width: '24px' }} /> {traducirPagina("Cliente").toUpperCase()}</MDBDropdownItem>

                                <MDBDropdownItem onClick={() => { setAbrirFichaSelecionTienda(true); }}> <UserSwitchOutlined style={{ fontSize: '18px', verticalAlign: 'initial', width: '24px' }} /> {traducirPagina("Cliente_tienda").toUpperCase()}</MDBDropdownItem>
                            </MDBDropdownMenu>
                        </MDBDropdown>
                    </div>
                </div>

                <div className="mantenimiento_item2" style={{ gap: '10px' }}>
                    <div>
                        {licencias !== null ?
                            licencias.length > 0 ?
                                <Pagination
                                    showSizeChanger
                                    current={datosPaginacion.iniPage}
                                    onShowSizeChange={(current, size) => { updateNumberPage(current, size) }}
                                    total={licencias.length}
                                    showTotal={() => ` ${licencias.length} ${traducirPagina("Licencias")}`}
                                    defaultPageSize={40}
                                    onChange={(page, pageSize) => { paginarTabla(page, pageSize) }}
                                > </Pagination>
                                :
                                null
                            : null
                        }
                    </div>
                </div>
            </div>



            <div className="margen_tabla">
                {licencias === null ?
                    <div style={{ textAlign: 'center' }}>
                        <h4>{traducirPagina("Msg_licencias")}</h4>
                    </div>
                    :
                    licencias.length > 0 ?

                        <div className="container_tabla_generico" style={{ height: `calc(100vh - ${(120 + alturaSubmenu)}px )` }}>
                            <table style={{ border: '1px solid #d9d9d9', width: '100%' }}>
                                <thead>
                                    <tr style={{ backgroundColor: '#e0e0e0' }}>
                                        <th style={{ width: '60px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }} onClick={(e) => {
                                            actualizarCabeceraTabla("ID", !cabeceraTabla.ID);

                                            setLicencias(ordenarTablaLocal(cabeceraTabla.ID ? "ASC" : "DESC", licencias, "ID"))
                                        }}> {traducirPagina("ID")} {cabeceraTabla.ID ? <ArrowUpOutlined className="orderTable" /> : <ArrowDownOutlined className="orderTable" />} </th>
                                        <th style={{ minWidth: '100px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }} onClick={(e) => {
                                            actualizarCabeceraTabla("Usuario", !cabeceraTabla.Usuario);

                                            setLicencias(ordenarTablaLocal(cabeceraTabla.Usuario ? "ASC" : "DESC", licencias, "USUARIO"))
                                        }}> {traducirPagina("Usuario")} {cabeceraTabla.Usuario ? <ArrowUpOutlined className="orderTable" /> : <ArrowDownOutlined className="orderTable" />} </th>
                                        <th style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }} onClick={(e) => {
                                            actualizarCabeceraTabla("Nombre", !cabeceraTabla.Nombre);

                                            setLicencias(ordenarTablaLocal(cabeceraTabla.Nombre ? "ASC" : "DESC", licencias, "NOMBRE_USUARIO"))
                                        }} > {traducirPagina("Nombre")} {cabeceraTabla.Nombre ? <ArrowUpOutlined className="orderTable" /> : <ArrowDownOutlined className="orderTable" />}</th>
                                        <th style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left', width: '200px' }} onClick={(e) => {
                                            actualizarCabeceraTabla("Taller", !cabeceraTabla.Taller);

                                            setLicencias(ordenarTablaLocal(cabeceraTabla.Taller ? "ASC" : "DESC", licencias, "NOMBRE_TALLER"))
                                        }} > {traducirPagina("Taller")} {cabeceraTabla.Taller ? <ArrowUpOutlined className="orderTable" /> : <ArrowDownOutlined className="orderTable" />}</th>
                                        <th style={{ minWidth: '100px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }} onClick={(e) => {
                                            actualizarCabeceraTabla("Almacen", !cabeceraTabla.Almacen);

                                            setLicencias(ordenarTablaLocal(cabeceraTabla.Almacen ? "ASC" : "DESC", licencias, "ALMACEN"))
                                        }} > {traducirPagina("Almacen")} {cabeceraTabla.Almacen ? <ArrowUpOutlined className="orderTable" /> : <ArrowDownOutlined className="orderTable" />}</th>
                                        <th style={{ minWidth: '100px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }} onClick={(e) => {
                                            actualizarCabeceraTabla("Cliente", !cabeceraTabla.Cliente);

                                            setLicencias(ordenarTablaLocal(cabeceraTabla.Cliente ? "ASC" : "DESC", licencias, "CLIENTE"))
                                        }} > {traducirPagina("Cliente")} {cabeceraTabla.Cliente ? <ArrowUpOutlined className="orderTable" /> : <ArrowDownOutlined className="orderTable" />}</th>
                                        <th style={{ minWidth: '100px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }} onClick={(e) => {
                                            actualizarCabeceraTabla("Creación", !cabeceraTabla.Creación);

                                            setLicencias(ordenarTablaLocal(cabeceraTabla.Creación ? "ASC" : "DESC", licencias, "ALTA"))
                                        }}> {traducirPagina("Creacion")} {cabeceraTabla.Creación ? <ArrowUpOutlined className="orderTable" /> : <ArrowDownOutlined className="orderTable" />}</th>


                                        <th style={{ minWidth: '100px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }} onClick={(e) => {
                                            actualizarCabeceraTabla("Baja", !cabeceraTabla.Baja);

                                            setLicencias(ordenarTablaLocal(cabeceraTabla.Baja ? "ASC" : "DESC", licencias, "FECHA_BAJA"))
                                        }}> {traducirPagina("Baja")} {cabeceraTabla.Baja ? <ArrowUpOutlined className="orderTable" /> : <ArrowDownOutlined className="orderTable" />}</th>


                                        <th style={{ minWidth: '160px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }} onClick={(e) => {
                                            actualizarCabeceraTabla("Ultimo", !cabeceraTabla.Ultimo);

                                            setLicencias(ordenarTablaLocal(cabeceraTabla.Ultimo ? "ASC" : "DESC", licencias, "ULTIMO_ACCESO"))
                                        }} > {traducirPagina("Ultimo_acceso")} {cabeceraTabla.Ultimo ? <ArrowUpOutlined className="orderTable" /> : <ArrowDownOutlined className="orderTable" />} </th>
                                        <th style={{ minWidth: '95px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }} onClick={(e) => {
                                            actualizarCabeceraTabla("Media", !cabeceraTabla.Media);

                                            setLicencias(ordenarTablaLocal(cabeceraTabla.Media ? "ASC" : "DESC", licencias, "MEDIA"))
                                        }} > {traducirPagina("Media")} {cabeceraTabla.Media ? <ArrowUpOutlined className="orderTable" /> : <ArrowDownOutlined className="orderTable" />}</th>
                                        <th style={{ minWidth: '80px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }} onClick={(e) => {
                                            actualizarCabeceraTabla("Activo", !cabeceraTabla.Activo);

                                            setLicencias(ordenarTablaLocal(cabeceraTabla.Activo ? "ASC" : "DESC", licencias, "BAJA"))
                                        }} > {traducirPagina("Activo")} {cabeceraTabla.Activo ? <ArrowUpOutlined className="orderTable" /> : <ArrowDownOutlined className="orderTable" />}</th>
                                        <th style={{ minWidth: '45px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }} onClick={(e) => {
                                            actualizarCabeceraTabla("EsMostrador", !cabeceraTabla.EsMostrador);

                                            setLicencias(ordenarTablaLocal(cabeceraTabla.EsMostrador ? "ASC" : "DESC", licencias, "ES_MOSTRADOR"))
                                        }} > {"T"} {cabeceraTabla.EsMostrador ? <ArrowUpOutlined className="orderTable" /> : <ArrowDownOutlined className="orderTable" />}</th>
                                        <th style={{ width: '180px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }} > </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <List list={licencias} />
                                </tbody>

                            </table>
                        </div>
                        :
                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '80vh' }}> <div className="spinner-border  fast colorSubAzul" role="status" disabled /> </div>
                }
            </div>


            {abrirFichaEstadistica ?
                <FichaEstadistica
                    title={traducirPagina("Estadistica_usuario").toUpperCase()}
                    ESTADO_FICHA={abrirFichaEstadistica}
                    CERRAR_FICHA={setAbrirFichaEstadistica}
                    ID_USUARIO={usuarioSeleccionado}
                    SOCIO={socioSeleccionado}
                    USUARIO={registroUsuario}
                ></FichaEstadistica>
                : null}


            <FichaImpresion title={traducirPagina("Impresion_doc").toUpperCase()} LICENCIAS={licencias} ID_SOCIO={socioSeleccionado}  ></FichaImpresion>

            {abrirFichaMostrador ?
                <FichaMantenimientoMostrador
                    title={traducirPagina("Mostrador").toUpperCase()}
                    ESTADO_FICHA={abrirFichaMostrador}
                    CERRAR_FICHA={setAbrirFichaMostrador}
                    ID_SOCIO={socioSeleccionado}
                    ID_USUARIO={usuarioSeleccionado}
                    ACTUALIZAR_LICENCIAS={licenciasSertec}
                    TEXTO_BUSCADOR={setTextoBuscador}>
                </FichaMantenimientoMostrador>
                :
                null
            }

            {abrirFichaSelecionCliente ?
                <FichaSelecionCliente
                    title={traducirPagina("Seleccione_cliente").toUpperCase()}
                    ABRIR_FICHA={abrirFichaSelecionCliente}
                    ACTUALIZAR_FICHA={setAbrirFichaSelecionCliente}
                    ID_SOCIO={socioSeleccionado}
                    ABRIR_FICHA_MANTENIMIENTO={setAbrirFichaCliente}
                    DATOS_CLIENTE_SELECCIONADO={setDatosClienteSeleccionado}


                    ID_TIENDA_RETAIL={datosClienteSeleccionado.ID_TIENDA_RETAIL}
                    ID_TIPO_INTEGRACION={datosClienteSeleccionado.ID_TIPO_INTEGRACION}
                    DATOS_TIENDA={datosTiendaRetail}
                >

                </FichaSelecionCliente>
                :
                null
            }

            {abrirFichaSelecionTienda ?
                <MantenimientoTienda
                    title={traducirPagina("Seleccione_tienda").toUpperCase()}
                    ABRIR_FICHA={abrirFichaSelecionTienda}
                    CERRAR_FICHA={setAbrirFichaSelecionTienda}
                    TIPO={""}

                    ID_SOCIO={socioSeleccionado}
                    MODO_SELECCION={true}
                    METODO_ALTA={altaClienteTienda}
                >

                </MantenimientoTienda>
                :
                null
            }


            <FichaMantenimientoCliente
                title={traducirPagina("Cliente").toUpperCase()}
                ESTADO_FICHA={abrirFichaCliente}
                CERRAR_FICHA={setAbrirFichaCliente}
                DATOS_CLIENTE_SELECCIONADO={setDatosClienteSeleccionado}
                ID_SOCIO={socioSeleccionado}
                ID_USUARIO={usuarioSeleccionado}
                DATOS_CLIENTE={datosClienteSeleccionado}
                ACTUALIZAR_LICENCIAS={licenciasSertec}
                TEXTO_BUSCADOR={setTextoBuscador}
            >
            </FichaMantenimientoCliente>


            <Modal
                visible={visible}
                width={600}
                centered
                title={traducirPagina("Dar_baja")}
                afterClose={() => { }}
                onCancel={() => setVisible(false)}
                style={{ zIndex: '99999999' }}
                footer={[
                    <Button key="back" onClick={() => { setVisible(false) }}>
                        {traducirPagina("NO")}
                    </Button>,
                    <Button style={{ backgroundColor: '#000' }} key="submit" type="primary" onClick={() => {
                        DarDeBajaUsuario(registroUsuario.ID)
                        setVisible(false)
                    }}> {traducirPagina("SI")}</Button>
                ]}
            >

                <Row>
                    <Col md={24} className="mt-2 mb-2">
                        <span className="tituloRecuperarEmail">{`${traducirPagina("Baja_usuario")}: ${registroUsuario.NOMBRE_USUARIO}?`} </span>
                    </Col>

                </Row>
            </Modal>
        </div>

    );
}


LicenciasSertec.propTypes = {

};

const mapStateToProps = (state, props) => {
    return {
        props: props,
        search: state.searchValue,
        configApp: state.configApp,
        usuario: state.usuario,
        clienteSeleccionado: state.clienteSeleccionado,
        activeItemReferencia: state.activeItemReferencia,

    };
}

export default connect(mapStateToProps)(LicenciasSertec);


